// "One Function That Exports Everything I Know About a User" — GDPR export short.
// Cold Compute / Neon kit. Built on the real EAKC function:
//   src/lib/data-lifecycle/gdpr-export.ts → exportUserData(userId, tenantId) (line 83).
// Every claim is grounded in that file + supabase/migrations/001_initial_schema.sql.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. Each duration ≈ round((lastCaption.fromSec + ~6) * 30)
// so the last caption is fully readable with no dead air. start/duration in frames @30fps.
export const SCENE = {
  hook: { start: 0, duration: 210 }, //        0:00–0:07  one function, whole user
  problem: { start: 210, duration: 390 }, //    0:07–0:20  GDPR Article 20 / portability
  shape: { start: 600, duration: 540 }, //      0:20–0:38  what the export gathers (5 buckets)
  exclude: { start: 1140, duration: 540 }, //   0:38–0:56  what it REFUSES to include
  code: { start: 1680, duration: 600 }, //      0:56–1:16  select-only columns = exclusion by design
  honest: { start: 2280, duration: 420 }, //    1:16–1:30  honesty: no HTTP route yet
  outro: { start: 2700, duration: 330 }, //     1:30–1:41
} as const;

export const TOTAL_DURATION = 3030; // 101s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
